import { Component, computed, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AlertComponent, ButtonComponent, PageHeaderComponent } from '@libs/common/components';
import { ShoppingListModel } from '@libs/shop/models';
import { ShoppingListsState, ViewportService } from '@libs/shared/services';
import { CreateAndEditShoppingListDialogComponent } from '../create-and-edit-shopping-list-dialog';
import { ShoppingListsDesktopComponent } from './desktop/shopping-lists-desktop.component';
import { ShoppingListsMobileComponent } from './mobile/shopping-lists-mobile.component';

@Component({
  selector: 'ui-shopping-lists',
  templateUrl: './shopping-lists.component.html',
  styleUrls: ['./shopping-lists.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ShoppingListsMobileComponent,
    ShoppingListsDesktopComponent,
    ButtonComponent,
    AlertComponent,
    CreateAndEditShoppingListDialogComponent,
    PageHeaderComponent,
  ],
})
export class ShoppingListsComponent implements OnInit {
  public isMobile: Signal<boolean> = toSignal(this.viewportService.isMobile(), { initialValue: true });
  public shoppingLists: Signal<ShoppingListModel[]> = this.shoppingListState.shoppingLists;
  public shoppingListsLoading: Signal<boolean> = this.shoppingListState.isLoading;
  public loadingError: Signal<boolean> = computed(() => !!this.shoppingListState.error());

  public constructor(
    public shoppingListState: ShoppingListsState,
    private readonly viewportService: ViewportService,
  ) {
  }

  public ngOnInit(): void {
    this.shoppingListState.reload();
  }
}
